/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOld = createReactComponent("old", "IconOld", [
  ["path", { d: "M11 21l-1 -4l-2 -3v-6", key: "svg-0" }],
  ["path", { d: "M5 14l-1 -3l4 -3l3 2l3 .5", key: "svg-1" }],
  ["path", { d: "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }],
  ["path", { d: "M7 17l-2 4", key: "svg-3" }],
  ["path", { d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5", key: "svg-4" }]
]);

export { IconOld as default };
//# sourceMappingURL=IconOld.js.map
